import React, { useState, useContext } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { MdLiveHelp } from "react-icons/md";
import HelpModal from "../../shared/HelpModal";
import HelpContext from "../../shared/context/HelpProvider";
import CustomAlert from "../../shared/CustemAlert";
import MyJustDate from "../../shared/MyJustDate";

const baseURL = process.env.REACT_APP_API_JOBS;

export default function Add({
  increment,
  counter,
  moamad,
  langOptions,
  langLevel,
  hagsha_aharon,
}) {
  const { showHelp, setShowHelp, saeef, setSaeef } = useContext(HelpContext);
  const [newLang, setNewLang] = useState({
    lang: "",
    read: "",
    write: "",
    speek: "",
    moamad: moamad.id,
  });
  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  let readOnly =
    moamad.signature_date ||
    MyJustDate(new Date(Date.parse(hagsha_aharon))) <
      MyJustDate(new Date(Date.now()));

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    setNewLang((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.post(
          baseURL + "language/",
          newLang,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setShowCustomAlert(true);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
  };

  // render
  return (
    <div>
      <HelpModal />
      <center>
        <div className="card text-dark bg-light container p-3  border">
          <div className="card-header">
            {moamad.signature_date ? (
              <h4 style={{ color: "green" }}>
                המעמדות שלך למכרז נחתמה ושוגרה, לא תוכל להוסיף עדכונים.
              </h4>
            ) : (
              <h4 style={{ color: "red" }}>
                <AiOutlineWarning />
                שים לב המועמדות שלך למכרז, עדיין לא נחתמה ולא שוגרה.
                <AiOutlineWarning />
              </h4>
            )}

            <h5
              onClick={() => {
                setSaeef("4-9");
                setShowHelp(true);
              }}
            >
              ידיעת שפות של המועמד: {moamad.f_name}{" "}
              {moamad.father_name ? moamad.father_name + " " : ""}{" "}
              {moamad.l_name}
              <span className="help">
                <MdLiveHelp />
              </span>
            </h5>
          </div>
          {!readOnly ? (
            <div className="card-body">
              <Row>
                <Col>
                  <form onSubmit={handleSubmit} className="mbsc-form-group">
                    <div className="form-group">
                      <label htmlFor="lang" className="required-label">
                        בחר שפה:{" "}
                      </label>{" "}
                      <br />
                      <select
                        name="lang"
                        onChange={handleChange}
                        value={newLang.lang}
                        required
                      >
                        <option key="0" value="" selected>
                          בחר שפה
                        </option>
                        {langOptions?.map((a) => (
                          <option key={a[0]} value={a[1]}>
                            {a[1]}
                          </option>
                        ))}
                      </select>
                    </div>
                    <br></br>
                    <Row>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="read" className="required-label">
                            רמת הקריאה
                          </label>
                          <br />
                          <select
                            name="read"
                            onChange={handleChange}
                            value={newLang.read}
                            required
                          >
                            <option key="0" value="" selected>
                              בחר רמה
                            </option>
                            {langLevel?.map((a) => (
                              <option key={a[0]} value={a[1]}>
                                {a[1]}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="write" className="required-label">
                            רמת הכתיבה
                          </label>
                          <br />
                          <select
                            name="write"
                            onChange={handleChange}
                            value={newLang.write}
                            required
                          >
                            <option key="0" value="" selected>
                              בחר רמה
                            </option>
                            {langLevel?.map((a) => (
                              <option key={a[0]} value={a[1]}>
                                {a[1]}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="speek" className="required-label">
                            רמת הדיבור
                          </label>
                          <br />
                          <select
                            name="speek"
                            onChange={handleChange}
                            value={newLang.speek}
                            required
                          >
                            <option key="0" value="" selected>
                              בחר רמה
                            </option>
                            {langLevel?.map((a) => (
                              <option key={a[0]} value={a[1]}>
                                {a[1]}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    </Row>

                    <br />
                    <button type="submit" className="btn btn-primary">
                      הוסף
                    </button>
                  </form>
                </Col>
              </Row>
              {showCustomAlert && (
                <div className="alert-max-width">
                  <CustomAlert
                    setShow={setShowCustomAlert}
                    alertHeader="הוספת שפה למועמד"
                    alertBody="השפה נוספה בהצלחה"
                  />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      </center>
    </div>
  );
}
